// External libraries
import { TextButton } from '@checkout/react-components';
import { bool } from 'prop-types';
import styled from '@emotion/styled';

// Internal modules
import { PRIMARY_COLOR } from '@/styles';

const getChevronDirection = ({ isOpen }) => `rotate(${isOpen ? -45 : 135}deg)`;

// The vertical position of the chevron depends on its direction (up/down)
const getVerticalOffset = ({ isOpen }) => {
  const divisor = isOpen ? 4 : 2;

  // Why `Math.sqrt(98)`? The chevron is a square with a side of 7px and a
  // border on the top and right sides. It is then rotated to point up or down.
  // The "height" of the rotated square is sqrt(7^2 + 7^2) === sqrt(98)
  return `translateY(-${Math.sqrt(98) / divisor}px)`;
};

const HonorFxButton = styled(TextButton)`
  line-height: 1.38;
  margin-top: 6px;
  padding-right: 17px;
  position: relative;

  /* Angle down/up chevron */
  &::after {
    border-color: ${PRIMARY_COLOR};
    border-style: solid;
    border-width: 2px 2px 0 0;
    content: '';
    height: 7px;
    position: absolute;
    right: 2px;
    top: 50%;
    transform: ${getVerticalOffset} ${getChevronDirection};
    width: 7px;
  }
`;

HonorFxButton.propTypes = {
  isOpen: bool.isRequired,
};

const HonorFxContent = styled.p`
  margin-top: 6px;
`;

export { HonorFxButton, HonorFxContent };
